<template>
  <div class="plr-bullet-list-widget backdrop-dark fade-up">
    <div class="hint-container scrollable">
      <div class="hint-toolbar">
        <button
          :disabled="!(bulletList?.duration && !isPaused)"
          @click="isPaused = true"
          class="btn-pause"
        />
        <button class="ctrl-c" @click="handleCopyClick" />
        <button class="btn-close" @click="handleCloseClick" />
      </div>
      <div class="plr-white-pane">
        <h4 v-if="bulletList?.title" :dir="getTextDirection(bulletList.title)">
          {{ bulletList.title }}
        </h4>
        <div class="pan-area">
          <ul id="animated-list">
            <li
              v-for="(v, i) in bulletList?.items ?? []"
              :key="i"
              :style="{
                animationDelay: `calc(var(--anim-delay-step) * ${i + 1})`
              }"
              :dir="getTextDirection(v)"
            >
              <span class="bullet" />
              <button
                v-if="bulletList?.clickable"
                @click="handleSelected(v)"
                :class="{ 'content-wrapper': true, active: activeItem === v }"
              >
                {{ v }}
              </button>
              <span v-else class="content-wrapper">{{ v }}</span>
            </li>
          </ul>
        </div>
        <div v-if="false" class="plr-sub-note">
          This data generated by AI and can not be truested. Please, trust your
          brain and verified sources.
        </div>
      </div>
      <ProgressBar
        :style="{
          visibility: bulletList?.duration && !isPaused ? 'visible' : 'hidden'
        }"
        :duration="bulletList.duration"
        :is-paused="isPaused"
        @end="handleProgressEnd"
        height="4"
        color="#FF681D"
        backgroundColor="#FFFFFF99"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";
import _ from "lodash";
import {
  BulletListDto,
  MessageType
} from "@moderrotech/servers-communication-library/src/types";
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import { getTextDirection } from "@/helpers/string";
import ProgressBar from "@/components/ProgressBar.vue";
/* eslint-disable */
// @ts-ignore
import {copyText} from 'vue3-clipboard'
/* eslint-enable */

export default {
  components: { ProgressBar },
  setup() {
    const store = useStore();

    const bulletList = computed(
      (): BulletListDto => store.state.session.bulletList
    );

    const activeItem = ref<string>();

    const isPaused = ref(false);

    return {
      bulletList,
      getTextDirection,
      activeItem,
      handleCopyClick: () =>
        copyText(
          _.join(bulletList.value?.items, "\n"),
          undefined,
          (error: any, event: any) =>
            error
              ? showToastError(i18n.global.t("call.error.textCopy"))
              : showToastSuccess(i18n.global.t("call.success.textCopy"))
        ),
      handleCloseClick: () => store.commit("session/UNSET_BULLET_LIST"),
      handleSelected: (text: string) => {
        activeItem.value = text;
        store.dispatch("session/sendJsonMessage", {
          message: {
            type: MessageType.bulletListClick,
            item: text
          }
        });
        store.commit("session/UNSET_BULLET_LIST");
      },
      handleProgressEnd: () => store.commit("session/UNSET_BULLET_LIST"),
      isPaused
    };
  }
};
</script>

<style lang="scss">
@import "../assets/styles/bullet-list.scss";
@import "../assets/styles/kiosk-landscape-30inch/bullet-list.scss";
@import "../assets/styles/kiosk-portrait-30inch/bullet-list.scss";
</style>
